import router from "@/router/router";

export const handleNonAuthentication = (): void => redirectToLogin(window.location.pathname);
export const redirectToLogin = (returnUrl: string): void => {
  router.replace({
    name: "account-login",
    query: { returnUrl },
  });
};

export const redirectToLogout = (): void => {
  router.replace({
    name: "accounts-logout",
  });
};
export const redirectTo = (targetUrl: string): void => {
  window.location.href = targetUrl;
};